import store from '@/store/index.js'
import http from "@/config/http.js";

// // 获取学院、系别、专业、班级选项
// export const getOrgOptions = function async(that, params, grade, searchIndex, formIndex) {
//     return new Promise((resolve) => {
//         http.get("/account/sys/org/listByType", { params }).then(res => {
//             // console.log(res)
//             let options = [];
//             if (res.code == store.state.dic.SUCCESS_CODE) {
//                 options = res.data.map(item => {
//                     return {
//                         label: item.name,
//                         value: item.id
//                     }
//                 })
//             }

//             if (typeof searchIndex == 'number') {
//                 if (params.type == 'department') {
//                     let majorParams = {
//                         parentId: options[0].value,
//                         type: 'major',
//                         grade,
//                     }
//                     getOrgOptions(that, majorParams, "", searchIndex + 1, null)
//                 } else {
//                     that.searchItems[searchIndex].options = options;
//                 }
//             }
//             if (typeof formIndex == 'number') {
//                 // 插入到第一个
//                 // options.unshift({
//                 //     label: '所有院系',
//                 //     value: '#root'
//                 // })

//                 if (params.type == 'department') {
//                     let majorParams = {
//                         parentId: options[0].value,
//                         type: 'major',
//                         grade,
//                     }
//                     getOrgOptions(that, majorParams, "", null, formIndex + 1)
//                 } else {
//                     that.formItems[formIndex].options = options;
//                 }
//             }
//             resolve();
//         }).catch(err => {
//             console.error(err);
//         })
//     })
// }


// 获取学院、系别、专业、班级选项
export const getOrgOptions = function (that, params, searchIndex, formIndex, searchItems = 'searchItems', formItems = 'formItems') {
     //查询非空班级
     params.isZero = "0";
    return new Promise((resolve) => {
        http.get("/account/sys/org/listMyOrg", { params }).then(res => {
            // console.log(res)
            let options = [];
            let data = res.data;
            if (res.code == store.state.dic.SUCCESS_CODE) {
                options = data.map(item => {
                    return {
                        label: item.name,
                        value: item.id
                    }
                })
            }
            if (typeof searchIndex == 'number') {
                if (params.type == 'department') {
                    let majorParams = {
                        parentId: options[0].value,
                        type: 'major',
                    }
                    getOrgOptions(that, majorParams, searchIndex + 1, null)
                } else {
                    that[searchItems][searchIndex].options = options;
                }
            }
            if (typeof formIndex == 'number') {
                if(params.type == 'college') {
                    options.unshift({
                        label: '所有院系',
                        value: '#root'
                    })
                }
                
                if (params.type == 'department') {
                    let majorParams = {
                        parentId: options[0].value,
                        type: 'major',
                    }
                    getOrgOptions(that, majorParams, null, formIndex + 1)
                } else {
                    that[formItems][formIndex].options = options;
                }
            }
            resolve();
        }).catch(err => {
            console.error(err);
        })
    })
}


// 获取角色选项
export const getRoleOptions = function (that, searchIndex, formIndex) {
    return new Promise((resolve) => {
        http.get("/account/sys/role/listAll").then(res => {
            // console.log(res)
            let options = [];
            if (res.code == store.state.dic.SUCCESS_CODE) {
                options = res.data.map(item => {
                    return {
                        label: item.name,
                        value: item.id
                    }
                })
            }
            if (typeof searchIndex == 'number') {
                that.searchItems[searchIndex].options = options;
            }
            if (typeof formIndex == 'number') {
                that.formItems[formIndex].options = options;
            }
            resolve();
        }).catch(err => {
            console.error(err);
        })
    })
}

// 获取迎新环节选项
export const getLinkOptions = function (that, searchIndex, formIndex) {
    return new Promise((resolve) => {
        http.get("/welcome-live/link/listAll").then(res => {
            // console.log(res)
            let options = [];
            if (res.code == store.state.dic.SUCCESS_CODE) {
                options = res.data.map(item => {
                    return {
                        label: item.linkName,
                        value: item.id
                    }
                })
            }
            if (typeof searchIndex == 'number') {
                that.searchItems[searchIndex].options = options;
            }
            if (typeof formIndex == 'number') {
                that.formItems[formIndex].options = options;
            }
            resolve();
        }).catch(err => {
            console.error(err);
        })
    })
}

// 获取迎新办理人
export const getUserOptions = function (that, searchIndex, formIndex) {
    return new Promise((resolve) => {
        http.get("/welcome-live/location/userList").then(res => {
            // console.log(res)
            let options = [];
            if (res.code == store.state.dic.SUCCESS_CODE) {
                options = res.data.map(item => {
                    return {
                        label: item.name + '(' + item.username + ')',
                        value: item.id
                    }
                })
            }
            if (typeof searchIndex == 'number') {
                that.searchItems[searchIndex].options = options;
            }
            if (typeof formIndex == 'number') {
                that.formItems[formIndex].options = options;
            }
            resolve();
        }).catch(err => {
            console.error(err);
        })
    })
}
